import React, { useEffect, useState } from "react";
import { Tag, X, Copy, Check } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const ReturningUserBanner = () => {
  const { t, lang } = useLanguage();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (user === undefined) return; // still loading
    const isReturning = localStorage.getItem("m16_returning_user") === "1";
    const dismissedToday = sessionStorage.getItem("m16_discount_banner_dismissed") === "1";
    if (isReturning && user === null && !dismissedToday) {
      const tm = setTimeout(() => setOpen(true), 900);
      return () => clearTimeout(tm);
    }
  }, [user]);

  const close = () => {
    sessionStorage.setItem("m16_discount_banner_dismissed", "1");
    setOpen(false);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText("WELCOME10");
      setCopied(true);
      toast.success(t("codeCopied"));
      setTimeout(() => setCopied(false), 2000);
    } catch (_) { /* ignore */ }
  };

  if (!open) return null;

  return (
    <div
      className={`fixed bottom-6 z-[70] ${lang === "ar" ? "left-6" : "right-6"} max-w-sm`}
      data-testid="returning-discount-banner"
    >
      <div
        className="relative bg-[#0A0A0B] border border-[#D4AF37]/50 rounded-2xl p-5 shadow-[0_24px_60px_-20px_rgba(212,175,55,0.4)] page-enter"
        style={{ background: "linear-gradient(135deg, rgba(212,175,55,0.10), rgba(10,10,11,0.95))" }}
      >
        <button
          onClick={close}
          data-testid="returning-banner-close"
          className="absolute top-2 end-2 p-1 text-[#9CA3AF] hover:text-[#D4AF37] transition-colors"
          aria-label="close"
        >
          <X size={14} />
        </button>

        <div className="flex items-start gap-3">
          <div className="shrink-0 w-10 h-10 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
            <Tag size={18} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-widest text-[#D4AF37]/80 mb-1">{t("welcomeBackEyebrow")}</div>
            <div className="font-display text-base leading-snug mb-1">{t("discountActiveTitle")}</div>
            <div className="text-xs text-[#9CA3AF] leading-relaxed mb-3">{t("discountActiveMsg")}</div>
            <button
              onClick={copy}
              data-testid="returning-banner-copy-btn"
              className="w-full inline-flex items-center justify-between gap-2 bg-[#0A0A0B] border border-dashed border-[#D4AF37] hover:border-solid rounded-lg py-2 px-3 transition-all"
            >
              <span className="font-display text-sm font-bold text-[#D4AF37] num-ltr tracking-wider">WELCOME10</span>
              {copied
                ? <Check size={14} className="text-[#10B981]" />
                : <Copy size={12} className="text-[#9CA3AF]" />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
